var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.7,
    height: 20.7,
    viewBox: "0 0 20.7 20.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_-Product-Icons",
    "data-name": "\\uD83D\\uDD0D-Product-Icons",
    transform: "translate(-2.65 -2.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_note_24_regular",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Color",
    "data-name": "\\uD83C\\uDFA8-Color",
    d: "M19.389,3A3.611,3.611,0,0,1,23,6.611v7.643a2.5,2.5,0,0,1-.732,1.768l-6.246,6.246A2.5,2.5,0,0,1,14.254,23H6.611A3.611,3.611,0,0,1,3,19.389V6.611A3.611,3.611,0,0,1,6.611,3Zm0,1.667H6.611A1.944,1.944,0,0,0,4.667,6.611V19.389a1.944,1.944,0,0,0,1.944,1.944h7.5V17.722a3.611,3.611,0,0,1,3.406-3.605l.2-.006h3.611v-7.5A1.944,1.944,0,0,0,19.389,4.667Zm.766,11.111H17.722a1.945,1.945,0,0,0-1.938,1.785l-.006.159v2.432Z",
    transform: "translate(-3 -3)",
    fill: "#212121",
    stroke: "#fff",
    strokeWidth: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.7780de8e463c2a06a44e6c4ad712d2ff.svg";
export { ForwardRef as ReactComponent };